type Narrowable = string | number | boolean | {} | undefined | null

type Tuple<T extends Narrowable[]> = readonly [...T]

export const tupleFromArray = <Elem extends Narrowable, List extends Elem[]>(args: [...List]) => tuple(...args)

export const tuple = <T extends Narrowable[]>(...args: T): Tuple<T> => args
